
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeedLowRight as ObiSpeedLowRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speed-low-right.js';
 
 
 

 
 export const ObiSpeedLowRight = createComponent({
   react: React,
   tagName: 'obi-speed-low-right',
   elementClass: ObiSpeedLowRightElement,
   events: {
     
   }
  });
 
 